/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnStationComponentType } from './en-station-component-type';
 /**
 *
 *
 * @export
 * @interface UpdateStationComponentDto
 */
export interface UpdateStationComponentDto {

    /**
     * PSN or serial number
     *
     * @type {string}
     * @memberof UpdateStationComponentDto
     */
    psn?: string;

    /**
     * @type {EnStationComponentType}
     * @memberof UpdateStationComponentDto
     */
    type?: EnStationComponentType;

    /**
     * @type {string}
     * @memberof UpdateStationComponentDto
     */
    manufacturer?: string;

    /**
     * @type {string}
     * @memberof UpdateStationComponentDto
     */
    supplier?: string;

    /**
     * @type {string}
     * @memberof UpdateStationComponentDto
     */
    purchased?: string;

    /**
     * @type {number}
     * @memberof UpdateStationComponentDto
     */
    warranty?: number;

    /**
     * @type {string}
     * @memberof UpdateStationComponentDto
     */
    note?: string;

    /**
     * @type {number}
     * @memberof UpdateStationComponentDto
     */
    id: number;
}
